module.exports = __webpack_public_path__ + "img/erp-logos_0040_acumatica.18ba70e6.jpg";